import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AuthService } from '../../shared/auth/auth.service';
import { FormControl, NgForm } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { } from 'googlemaps';
import { GymInfo } from '../../_models/_firebaseObjects/GymInfo';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CrmPostService } from '../../_services/crm-post.service';
import { Subscription } from 'rxjs/Rx';
import { init } from 'ityped'
import { TermsModalComponent } from './terms-modal/terms-modal.component';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit, OnDestroy, AfterViewInit {
  formData = {
    email: '',
    password: '',
    gymName: '',
    contactNumber: '',
    personName: '',
    gymAddress: '',
    verifiedPassword: ''
  };
  emailToSend = false;
  searchText: '';
  passwordsMatch = false;
  showPasswordsNotMatchWarning = false;
  signUpErrorMessage = '';

  latitude: number;
  longitude: number;
  zoom: number;

  sendToCrmSubs: Subscription;

  searchInput: FormControl;

  @ViewChild('searchInput') searchElementRef: ElementRef;

  constructor(
    private authService: AuthService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    private modalService: NgbModal,
    private crmService: CrmPostService) { }

  ngOnInit() {
    this.searchInput = new FormControl();

    this.zoom = 4;
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ['address']
      });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          this.formData.gymAddress = place.formatted_address;
          // this.searchInput.setValue(place.formatted_address);
        })
      })
    })
  }

  ngAfterViewInit() {
    init('#ityped', {
      showCursor: false,
      strings: [
        'classes',
        'challenges',
        'engagement',
        'retention',
        'upsell',
        'feedback',
        'members'
      ],
      typeSpeed:  80,
      backSpeed:  50,
      startDelay: 500,
      backDelay:  4000
    });
  }

  onSubmit(content, signUpForm) {
    // console.log(signUpForm);
    this.authService.signUpUser(this.formData.email, this.formData.password).then((data: firebase.auth.UserCredential) => {
      const gym = new GymInfo();
      gym.email = this.formData.email;
      gym.contactNumber = this.formData.contactNumber;
      gym.gymAddress = this.formData.gymAddress;
      gym.gymName = this.formData.gymName;
      gym.personName = this.formData.personName;
      gym.lat = this.latitude;
      gym.long = this.longitude;
      gym.gymID = data.user.uid.toString();
      gym.gymUID = data.user.uid.toString();
      console.log(gym);

      this.authService.signUpGym(gym).then(() => {
        this.emailToSend = true;
        // TODO uncomment when verificatin is fixed
        // this.authService.sendEmailVerification(gym.email).then(() => {
        //   (document.getElementById('crm-companyhub-form') as any).submit();
        //   signUpForm.reset();
        //   this.searchElementRef.nativeElement.value = '';
        // })
        this.onSignUp(signUpForm);
      });
    }, reason => this.signUpErrorMessage = reason.message);

  }

  verifyPassword(value) {
    if (value.length <= 3) {
      this.showPasswordsNotMatchWarning = false;
    } else {
      if (value === this.formData.password) {
        this.passwordsMatch = true;
        this.showPasswordsNotMatchWarning = false;
      } else {
        this.passwordsMatch = false;
        this.showPasswordsNotMatchWarning = true;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.sendToCrmSubs) {
      this.sendToCrmSubs.unsubscribe();
    }
  }

  showTermsModal(): void {
    this.modalService.open(TermsModalComponent);
  }

  // TODO Delete this method when verification is fixed
  private onSignUp(signUpForm: NgForm) {
    (document.getElementById('crm-companyhub-form') as any).submit();
    signUpForm.reset();
    this.searchElementRef.nativeElement.value = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sign-up/sign-up.component.ts